export default function Credibility() {
  const expertise = [
    { icon: 'ri-music-2-line', label: 'Dance &amp; Movement' },
    { icon: 'ri-code-box-line', label: 'Technology &amp; UE5' },
    { icon: 'ri-heart-pulse-line', label: 'Wellness Practice' },
    { icon: 'ri-team-line', label: 'Team Facilitation' },
    { icon: 'ri-film-line', label: 'Live Production' }
  ];

  return (
    <section className="py-32 bg-[#0D1B2A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="text-cyan-400 text-sm font-semibold tracking-widest uppercase mb-6">
            Delivered By Experts
          </div>
          
          <h2 className="font-serif text-5xl md:text-7xl font-bold text-white leading-tight">
            <span className="block mb-4">Designed by dancers.</span>
            <span className="block mb-4">Built by technologists.</span>
            <span className="block">Guided by wellness practitioners.</span>
          </h2>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-12 relative">
          {/* Connecting Lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ zIndex: 0 }}>
            <line x1="20%" y1="50%" x2="35%" y2="50%" stroke="#00D9FF" strokeWidth="1" opacity="0.3" strokeDasharray="5,5">
              <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite" />
            </line>
            <line x1="35%" y1="50%" x2="50%" y2="50%" stroke="#00D9FF" strokeWidth="1" opacity="0.3" strokeDasharray="5,5">
              <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite" />
            </line>
            <line x1="50%" y1="50%" x2="65%" y2="50%" stroke="#00D9FF" strokeWidth="1" opacity="0.3" strokeDasharray="5,5">
              <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite" />
            </line>
            <line x1="65%" y1="50%" x2="80%" y2="50%" stroke="#00D9FF" strokeWidth="1" opacity="0.3" strokeDasharray="5,5">
              <animate attributeName="stroke-dashoffset" from="0" to="10" dur="1s" repeatCount="indefinite" />
            </line>
          </svg>

          {expertise.map((item, index) => (
            <div 
              key={index}
              className="relative z-10 w-44 h-40 rounded-2xl bg-[#16213E] flex flex-col items-center justify-center gap-4 hover:bg-[#1F2B4A] hover:-translate-y-2 hover:shadow-2xl hover:shadow-cyan-500/20 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className={`${item.icon} text-5xl text-white group-hover:text-cyan-400 transition-colors duration-300`}></i>
              </div>
              <span className="text-white text-lg text-center font-semibold px-4" dangerouslySetInnerHTML={{ __html: item.label }}></span>
            </div>
          ))}
        </div>

        <div className="mt-24 max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-[#16213E] to-[#1A2540] rounded-3xl p-12 border border-cyan-400/20">
            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center">
                  <i className="ri-award-line text-5xl text-white"></i>
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="text-3xl font-bold text-white mb-4">
                  Official Pre-Competition Experience
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed mb-6">
                  Groove &amp; Glow serves as Singapore's exclusive warm-up experience for the Ultimate Freestyle War 
                  competition in Hong Kong — a prestigious international dance event that brings together the world's 
                  top freestyle performers.
                </p>
                <p className="text-cyan-400 font-semibold">
                  Reimagined as an inclusive, corporate-ready workshop for teams of all skill levels.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Meet The Team
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
